export const fieldTitle = (type) => {
  switch (type) {
    case 1:
      return 'Text Field';
    case 2:
      return 'Email Field';
    case 4:
      return 'Number Field';
    case 6:
      return 'Phone Number Field';
    case 5:
      return 'Date Field';
    case 9:
      return 'Dropdown Field';
    case 10:
      return 'Attachment Field';
    case 8:
      return 'Radio Button Field';
    default:
      return 'Checkbox Field';
  }
};
